import React from 'react'
import PageBody from 'Common/Custom/PageBody'
import AddItemBtn from 'Common/Custom/AddItemBtn'
import { HeadingOne } from 'Common/Custom/HeadingOne'

import HousekeepingListTable from './Components/HousekeepingListTable'

const HousekeepingList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Housekeeping List</HeadingOne>
                    <AddItemBtn url="add-housekeeping" title="Create" />
                </>
            }>

            {/* Table section */}
            <div className="col-12">
                <HousekeepingListTable />
            </div>
        </PageBody>
    )
}

export default HousekeepingList
